import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'
import Button from '../../components/common/Button/Button.tsx'
import Card from '../../components/common/Card/Card.tsx'
import Input from '../../components/common/forms/Input/Input.tsx'
import Loader from '../../components/common/Loader/Loader.tsx'
import { useAuth } from '../../context/auth'
import { useBusinessDetailsForm } from '../../hooks/useBusinessDetailsForm.ts'
import { isUserExistsInGroup } from '../../utils/userRights.ts'

const BusinessDetails = ({
  setStep
}: {
  setStep: React.Dispatch<React.SetStateAction<number>>
}) => {
  const navigate = useNavigate()
  const { state } = useAuth()
  const isRestrictedUser = isUserExistsInGroup(
    state.groups,
    'dd_panel_restricted_users'
  )
  const isCertificateRequiredUser = isUserExistsInGroup(
    state.groups,
    'certificate_required_users_group_name'
  )
  const { formik, loading, company } = useBusinessDetailsForm()

  useEffect(() => {
    if (formik.status && isRestrictedUser) {
      setStep(2)
    }
  }, [formik.status])

  return (
    <div className={'mt-6'}>
      <Breadcrumbs pageName="Dane firmowe" breadcrumbs={[]} />
      {!loading && !company && !isCertificateRequiredUser && (
        <div className=" text-[20px] text-red-400">
          Proszę uzupełnić dane firmowe aby przejść do kolejnego kroku.
        </div>
      )}
      {!loading && company && !isCertificateRequiredUser && (
        <Button
          variant="filled"
          size="medium"
          color="primary"
          className="mt-6"
          onClick={() => {
            if (isRestrictedUser) {
              setStep(2)
              localStorage.setItem(
                'agreement-' + state.email,
                JSON.stringify({ user: state.email, step: '2' })
              )
            }
            navigate('/account/usage-policy/')
          }}
        >
          {'Przejdź dalej'}
        </Button>
      )}
      <div className="mt-6">
        <Card>
          {loading && <Loader label={'Pobieranie danych...'} />}
          {!loading && (
            <Card.Body>
              <form onSubmit={formik.handleSubmit}>
                <Input
                  id="representative_first_name"
                  name="representative_first_name"
                  type="text"
                  placeholder="Imię właściciela"
                  formik={formik}
                />

                <Input
                  id="representative_last_name"
                  name="representative_last_name"
                  type="text"
                  placeholder="Nazwisko właściciela"
                  formik={formik}
                />

                <Input
                  id="company_name"
                  name="company_name"
                  type="text"
                  placeholder="Nazwa firmy"
                  formik={formik}
                />

                <Input
                  id="address1"
                  name="address1"
                  type="text"
                  placeholder="Ulica"
                  formik={formik}
                />

                <Input
                  id="building"
                  name="building"
                  type="text"
                  placeholder="Numer budynku"
                  formik={formik}
                />

                <Input
                  id="flat_number"
                  name="flat_number"
                  type="text"
                  placeholder="Numer mieszkania"
                  formik={formik}
                />

                <Input
                  id="address2"
                  name="address2"
                  type="text"
                  placeholder="Adres 2"
                  formik={formik}
                />

                <Input
                  id="postal_code"
                  name="postal_code"
                  type="text"
                  placeholder="Kod pocztowy"
                  formik={formik}
                  // value={formik.values.postal_code}
                  onChange={(e) => {
                    let value = e.target.value.replace(/[^0-9-]/g, '')
                    // Jeśli ktoś wpisze dwie cyfry a potem trzecią cyfrę (bez '-')
                    if (/^\d{3}/.test(value) && value[2] !== '-') {
                      value = value.slice(0, 2) + '-' + value.slice(2, 5)
                    }
                    // Jeśli po dwóch cyfrach wpisano "-", zachowaj do 6 znaków
                    else if (/^\d{2}-/.test(value)) {
                      value = value.slice(0, 6)
                    }
                    // Jeśli długość 2, nic nie rób
                    else if (value.length > 2 && value[2] !== '-') {
                      value = value.slice(0, 2) + '-' + value.slice(2, 5)
                    }

                    value = value.slice(0, 6)
                    formik.setFieldValue('postal_code', value)
                  }}
                  onBlur={formik.handleBlur}
                  maxLength={6}
                />

                <Input
                  id="city"
                  name="city"
                  type="text"
                  placeholder="Miasto"
                  formik={formik}
                />

                <Input
                  id="nip"
                  name="nip"
                  type="text"
                  placeholder="NIP"
                  formik={formik}
                  onChange={(e) => {
                    let value = e.target.value.replace(/[^0-9]/g, '') // Only digits
                    formik.setFieldValue('nip', value)
                  }}
                  maxLength={10}
                />

                <Button
                  variant="filled"
                  size="medium"
                  color="primary"
                  type="submit"
                  className="my-8"
                  disabled={!formik.isValid || formik.isSubmitting}
                >
                  {formik.isSubmitting ? 'Wysyłanie...' : 'Zapisz'}
                </Button>
              </form>
            </Card.Body>
          )}
        </Card>
      </div>
    </div>
  )
}

export default BusinessDetails
